import { colors } from 'theme'
import { color } from 'theme/tokens/color'
import { palette } from 'theme/tokens/palette'

export const defaultThemeStyles = {
    text: colors.white,
    col1: color.bgDarkTertiary,
    col2: color.bgDarkQuaternary,
    col3: color.bgDarkQuinary,
    setting: palette.white[400],
    settingActive: colors.white,
    sampleBackground: color.bgDarkQuinary,
}
